import { render } from "./NextEvents.vue?vue&type=template&id=433ad0ca&scoped=true"
import script from "./NextEvents.vue?vue&type=script&lang=js"
export * from "./NextEvents.vue?vue&type=script&lang=js"

import "./NextEvents.vue?vue&type=style&index=0&id=433ad0ca&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-433ad0ca"]])

export default __exports__